import { useEffect, useState } from 'react';

interface Props<T> {
    value: T;
    delay: number;
}
/**
 * Custom hook that debounces a value by delaying its update until after
 * the specified delay period has elapsed since the last change.
 */
export function useDebounce<T>({ value, delay = 3000 }: Props<T>): T {
    const [debouncedValue, setDebouncedValue] = useState<T>(value);

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        // Cancel the timer if value changes before delay completes
        return () => {
            clearTimeout(timer);
        };
    }, [value, delay]);

    return debouncedValue;
}
